// extracted by mini-css-extract-plugin
export var arrow = "Arrow-module--arrow--ebcb2";
export var line = "Arrow-module--line--c3114";